import { render, staticRenderFns } from "./PoliceBookTable.vue?vue&type=template&id=c721aa50&scoped=true"
import script from "./PoliceBookTable.vue?vue&type=script&lang=js"
export * from "./PoliceBookTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c721aa50",
  null
  
)

export default component.exports